import React from 'react'

import Headings from '@/components/BookLandingPageComp/landingPage/heading'
import RenderIf from '@/components/Common/RenderIf'


interface WhoShouldReadThisProps {
  isOrange?: boolean;
  landingPageData: any;
}

const WhoShouldReadThis = ({ isOrange = false, landingPageData }: WhoShouldReadThisProps) => {


  return (
    <RenderIf condition={isOrange && landingPageData?.form?.whoShouldReadThisBook?.length > 0}>
      <div>
        <Headings heading='WHO SHOULD READ THIS' />
        <div className='flex flex-col gap-3 mt-4'>
          {landingPageData?.form?.whoShouldReadThisBook?.map((text: any, index: number) => (
            <div
              key={index}
              className='rounded-lg md:p-3.5 p-3'
              style={{
                border: '1px solid rgba(255, 255, 255, 0.14)',
                background: 'radial-gradient(67.49% 179.15% at 50% 50.31%, rgb(15, 15, 15) 0%, rgb(45, 45, 45) 100%)',
              }}
            >
              <div className='mb-2.5'>
                <span className='text-sm font-medium text-grayZl-500'>
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className='sm:mt-1 w-5 h-[2px] bg-primary rounded-full' />
              </div>
              <p className='text-white text-sm font-medium leading-relaxed'>
                {text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </RenderIf>
  )
}

export default WhoShouldReadThis